<template>
  <div id="voucher-view">

    <!-- CONTENT -->

    <div id="wideContent">

      <div class="box">

        <div class="boxContent">

          <h1>Dárkové poukazy</h1>

          <p>
            Psí salon Jája zavedl prodej Dárkových poukazů, kterými můžete obdarovat své zvířecí kamarády, např. jako <b>dárek k Vánocům</b>.
					</p>

          <p>
            Poukaz umožňuje využít veškerých salonem nabízených služeb, a to až do výše částky uvedené na dárkovém poukazu.
            V případě, že celková cena využitých služeb přesáhne hodnotu poukazu, je možné zbývající částku uhradit při návštěvě salonu.
            Poukaz má platnost po dobu čtyř měsíců ode dne zakoupení a je nutné se objednat alespoň 3 dny předem.
            Poukazy jsou prodávány celoročně a je tedy možné je využít k nejrůznějším příležitostem.
          </p>

          <a :href="require('../../../static/photos/voucher/voucher-preview.jpg')" class="fancybox" title="Dárkový poukaz"><img style="border: 1px solid #D75974" src="../../../static/photos/voucher/thumb_voucher-preview.jpg" width="460px"/></a>

        </div>
      </div>

      <div class="cleaner">
        <!-- / -->
      </div>

    </div>

    <!-- /CONTENT -->

  </div>
</template>

<script>
  import fancybox from './../../assets/js/fancybox'

  export default {
    name: 'voucher-view',
    head: {
      title: { inner: 'Psí Salon Jája', separator: '-', complement: 'dárkové poukazy' },
      meta: [
        { id: 'description', content: 'Psí Salon Jája umožňuje nákup dárkových poukazů vhodných k nejrůznějším příležitostem.' },
        { id: 'keywords', content: 'dárkové poukazy, dárkový poukaz, poukazy, poukaz, voucher' }
      ]
    },
    mounted () {
      fancybox('#voucher-view .fancybox')
    }
  }
</script>



// WEBPACK FOOTER //
// VoucherView.vue?4e6b7e9c